import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const ctaBackgroundColors = [
  BackgroundColor.PURPLE,
  BackgroundColor.LIME,
  BackgroundColor.MINT,
  BackgroundColor.STONE,
  BackgroundColor.PURPLE_TINT,
  BackgroundColor.LIME_TINT,
  BackgroundColor.MINT_TINT,
  BackgroundColor.BERRY_TINT,
  BackgroundColor.ORANGE_TINT
] as const

export type CtaBackgroundColor = (typeof ctaBackgroundColors)[number]
